import { Card, styled, keyframes } from "@mui/material";


const borderColorChange = keyframes`
  0% {
    border-color: #43B4B9;
  }
  33% {
    border-color: #596035;
  }
  66% {
    border-color: #562984;
  }
  100% {
    border-color: #43B4B9;
  }
`;


const StyledCard = styled(Card)`
flex: 1;
width: auto;
height: auto;
background-color: #1E1E1E;
background-image: none;
border-radius: 15px;
/* border: 3px solid #449095; */
animation: ${borderColorChange} 3s linear infinite;
`;

export default StyledCard